import React from 'react'
import { Helmet } from 'react-helmet'
import HomeLayout from '../pageLayouts/HomeLayout'
import { APP_NAME } from '../configs/constant'

const home = () => {
  return (
    <HomeLayout>
      <Helmet>
        <title>{APP_NAME}</title>
      </Helmet>
    </HomeLayout>
  )
}

export default home
